/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { VueRouter } from '@/Constants/VueRouter'

/**************************************************************************************************/
/** @import Mixins                                                                               **/
/**************************************************************************************************/
import MixinResponsive from '@/Mixins/MixinResponsive'

/**************************************************************************************************/
/** @internal Const @name AdminNavigation                                                        **/
/**************************************************************************************************/
const AdminNavigation = defineComponent(
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	name: 'AdminNavigation', mixins: [MixinResponsive],

	props:
	{
		selected: Number
	},

	/*************************************************/
	/** @Data                                       **/
	/*************************************************/
	data()
	{
		return {
			items:
			[
				{ name: VueRouter.Views.Modules.Administration.ExternalUsersView.NAME, label: 'Usuarios Clientes' },
				{ name: VueRouter.Views.Modules.Administration.InternalUsersView.NAME, label: 'Usuarios Internos' },
				{ name: VueRouter.Views.Modules.Administration.StoragesView.NAME, label: 'Gestión Plantas' },
				{ name: VueRouter.Views.Modules.Administration.ConfigurationView.NAME, label: 'Configuraciones' }
			]
		}
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		OnItemClick({ name }: any) : void
		{
			this.$router.push({ name })
		}
	}
})

/**************************************************************************************************/
/** @export Component @name AdminNavigation                                                      **/
/**************************************************************************************************/
export default AdminNavigation

/**************************************************************************************************/
/** @export Type @name AdminNavigationRef                                                        **/
/**************************************************************************************************/
export type AdminNavigationRef = InstanceType<typeof AdminNavigation>